<div class="process-page-container">
  <h2 class="table-title">Cadastro de Processo</h2>
  <button mat-raised-button class="primary" (click)="openCreateProcessDialog()">
    + Novo Processo
  </button>

  <h2 class="table-title">Filtros de Processo</h2>
  <button
    mat-raised-button
    class="secondary"
    (click)="openProcessFilterDialog()"
  >
    Filtros de Processos
  </button>
  <button
    mat-raised-button
    class="secondary"
    (click)="openRequirementFilterDialog()"
  >
    Filtros de Requerimento
  </button>

  <h2 class="table-title">O que você deseja fazer?</h2>
  <button mat-raised-button class="consultar-button" (click)="consultProcesses()">Consultar</button>
  <button mat-raised-button class="limpar-filtros-button">Limpar Filtros</button>
<button mat-raised-button class="meus-filtros-button">Meus filtros</button>
<button mat-raised-button class="salvar-filtros-button">Salvar Filtros</button>
<div class="header-actions">
  <button mat-raised-button class="sync">Sincronizar Processos Offline</button>
</div>

  <!-- Page Title -->
  <div class="table-section">
    <h2 class="table-title">Seus Processos</h2>
    <div class="table-container">
      <app-process-table [processes]="filteredProcesses"></app-process-table>
    </div>
  </div>
</div>
